class WarehouseLeased {
	constructor(id, gameUserId, warehouseId, startTurn, endTurn) {
		this.id = id;
		this.gameUserId = gameUserId;
		this.warehouseId = warehouseId;
		this.startTurn = startTurn;
		this.endTurn = endTurn;
	}

	toPlainObj() {
		return {
			id: this.id,
			gameUserId: this.gameUserId,
			warehouseId: this.warehouseId,
			startTurn: this.startTurn,
			endTurn: this.endTurn
		};
	}
}

export default function LeasedWarehouseBuilder() {
	return {
		withId: function (id) {
			this.id = id;
			return this;
		},
		withGameUserId: function (gameUserId) {
			this.gameUserId = gameUserId;
			return this;
		},
		withWarehouseId: function (warehouseId) {
			this.warehouseId = warehouseId;
			return this;
		},
		withStartTurn: function (startTurn) {
			this.startTurn = startTurn;
			return this;
		},
		withEndTurn: function (endTurn) {
			this.endTurn = endTurn;
			return this;
		},
		build: function () {
			return new WarehouseLeased(
				this.id,
				this.gameUserId,
				this.warehouseId,
				this.startTurn,
				this.endTurn
			);
		}
	};
}

export function CreateLeasedWarehouseModel(warehouse, warehouseInfo) {
	const warehouseLeaseInfo = new LeasedWarehouseBuilder()
		.withId(warehouse.id)
		.withGameUserId(warehouse.game_user_id)
		.withWarehouseId(warehouse.warehouse_id)
		.withStartTurn(warehouse.start_turn)
		.withEndTurn(warehouse.end_turn)
		.build().toPlainObj();

	return {
		...warehouseLeaseInfo,
		slug: warehouseInfo.slug,
		address: warehouseInfo.address,
		price: warehouseInfo.price,
		extraFurnitureCapacity: warehouseInfo.extraFurnitureCapacity,
		description: warehouseInfo.description
	};
}
